import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../VideoPlayer.module.scss";
export const VideoPlayerPoster = ({ poster, alt, title }) => {
    if (!poster.length)
        return null;
    return (_jsx("img", { "data-testid": "videoPlayerPoster", className: styles.videoPlayerPosterImage, alt: alt, title: title, src: poster }));
};
//# sourceMappingURL=VideoPlayerPoster.js.map